// redux/slices/moduleSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Module {
  id: string;
  moduleName: string;
  moduleDescription: string;
  courseId: string;
  isActive: boolean;
  courseLearningLink: { linkDisplayName: string; url: string }[];
}

interface ModuleState {
  modules: Module[];
  needRefresh: boolean;
}

const initialState: ModuleState = {
  modules: [],
  needRefresh: true,
};

const moduleSlice = createSlice({
  name: "module",
  initialState,
  reducers: {
    setModules: (state, action: PayloadAction<Module[]>) => {
      state.modules = action.payload;
      state.needRefresh = false;
    },
    setModuleNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setModules, setModuleNeedRefresh } = moduleSlice.actions;
export default moduleSlice.reducer;
